import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Button, Col, Input} from "reactstrap";
import {Link, Redirect} from "react-router-dom";
import {useTranslation} from "react-i18next";

import {createExpressBot} from "../../../thunks/Connect";
import {renderErrorsAsHTML} from "../../../Components/utils";
import {clearErrors} from "../../../actions/Connect";
import get from "lodash/get";


const ExpressBot = (
    {
        activeShop,
        createExpressBot,
        isSendingRequest,
        errors,
        clearErrors,
    }
) => {
    const {t, i18n} = useTranslation();

    const [name, setName] = useState(undefined);
    const [expressId, setExpressId] = useState(undefined);
    const [expressAppId, setExpressAppId] = useState(undefined);
    const [expressSecretKey, setExpressSecretKey] = useState(undefined);
    const [redirectTo, setRedirectTo] = useState(undefined);

    // ComponentDidMount
    useEffect(() => {
        clearErrors();
    }, []);

    const dashboardUrl = `/${activeShop.id}/dashboard`;

    const onButtonClick = (event) => {
        createExpressBot(
            activeShop.id,
            name,
            expressId,
            expressAppId,
            expressSecretKey,
            (result) => setRedirectTo(dashboardUrl),
        );
    };

    if (redirectTo) {
        return <Redirect to={redirectTo}/>
    }

    return <div className="d-flex justify-content-center align-items-center">
        <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100 mx-auto">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="app-header__logo w-100 justify-content-center">
                            <div className="logo-src"/>
                        </div>

                        <div className="h5 modal-title text-center">
                            <h4 className="mt-4">
                                <div>
                                    {t('connect_bot.express.title', 'Connect Express bot')}
                                </div>

                                <div className='font-size-md mt-4 opacity-10'>
                                    {t('connect_bot.express.caption', 'Bot parameters')}:
                                </div>
                            </h4>
                        </div>

                        <div className='d-flex flex-column justify-content-center mb-3'>
                            <Input
                                placeholder="Name"
                                value={name}
                                onChange={(event) => setName(event.target.value)}
                            />
                            <small className="text-danger mt-1">{get(errors, 'name')}</small>
                        </div>
                        <div className='d-flex flex-column justify-content-center my-3'>
                            <Input
                                placeholder="ID"
                                value={expressId}
                                onChange={(event) => setExpressId(event.target.value)}
                            />
                            <small className="text-danger mt-1">{get(errors, 'express_id')}</small>
                        </div>
                        <div className='d-flex flex-column justify-content-center my-3'>
                            <Input
                                placeholder="APP_ID"
                                value={expressAppId}
                                onChange={(event) => setExpressAppId(event.target.value)}
                            />
                            <small className="text-danger mt-1">{get(errors, 'express_app_id')}</small>
                        </div>
                        <div className='d-flex flex-column justify-content-center my-3'>
                            <Input
                                placeholder="Secret key"
                                value={expressSecretKey}
                                onChange={(event) => setExpressSecretKey(event.target.value)}
                            />
                            <small className="text-danger mt-1">{get(errors, 'express_secret_key')}</small>
                        </div>
                        <div className='d-flex justify-content-center my-3'>
                            <Button
                                color='primary'
                                onClick={onButtonClick}
                                disabled={isSendingRequest}
                            >
                                {t('connect_bot.common.submit', 'Connect')}
                            </Button>
                        </div>

                        <div className="text-center text-danger">
                            {renderErrorsAsHTML(errors)}
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <Link to={dashboardUrl} className="btn-lg btn btn-link">
                            {t('connect_bot.common.back_to_bot_list', 'Back to bots list')}
                        </Link>
                    </div>
                </div>
            </div>
        </Col>
    </div>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
    errors: state.Connect.errors,
    isSendingRequest: state.Connect.isSendingRequest,
});

const mapDispatchToProps = dispatch => ({
    createExpressBot: (shop_id, name, express_id, express_app_id, express_secret_key, callback) => dispatch(createExpressBot(shop_id, name, express_id, express_app_id, express_secret_key, callback)),
    clearErrors: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpressBot);
